import React, { useEffect, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { SetCurrentPage } from '../../common/actions/pageAction';
import { ClearSportsList, SetLeague, SetLocation, SetSportId } from '../../common/actions/sportsAction';
import { getAllCount, isEmpty } from '../../common/cores';

const virtual = [

    {
        kind: "축구",
        gameCount: 0,
        imgPath: "../images/swip/icon_football.png",
        id: "soccer",
    },
    {
        kind: "농구",
        gameCount: 0,
        imgPath: "../images/swip/icon_basketball.png",
        id: "basket",
    }
]

const Swipbox = (props) => {
    let sports = [
        {
            kind: "전체",
            gameCount: 0,
            imgPath: "../images/swip/icon_all.png",
            id: "all",
        },
        {
            kind: "축구",
            gameCount: 0,
            imgPath: "../images/swip/icon_football.png",
            id: 6046,
        },
        {
            kind: "아이스하키",
            gameCount: 0,
            imgPath: "../images/swip/icon_ice_hockey.png",
            id: 35232
        },
        {
            kind: "농구",
            gameCount: 0,
            imgPath: "../images/swip/icon_basketball.png",
            id: 48242,
        },
        {
            kind: "배구",
            gameCount: 0,
            imgPath: "../images/swip/icon_volleyball.png",
            id: 154830,
        },
        {
            kind: "야구",
            gameCount: 0,
            imgPath: "../images/swip/icon_baseball.png",
            id: 154914,
        },
        {
            kind: "MMA",
            gameCount: 0,
            imgPath: "../images/swip/icon_mma.svg",
            id: 154919,
        },
        {
            kind: '탁구',
            gameCount: 0,
            id: 265917,
            imgPath: '../images/swip/jongmok_Tabletennis-ico.png'
        },
        {
            kind: '미식축구',
            gameCount: 0,
            id: 131506,
            imgPath: '../images/swip/rugby-league-ico.png'
        },
        {
            kind: '테니스',
            gameCount: 0,
            id: 54094,
            imgPath: '../images/swip/jongmok_Tennis.png'
        },
        {
            kind: '크리케트',
            gameCount: 0,
            id: 452674,
            imgPath: '../images/swip/jongmok_Cricket.png'
        },
    ]
    let esports = [
        {
            kind: "전체",
            gameCount: 0,
            imgPath: "../images/swip/icon_all.png",
            id: "all",
        },
        {
            kind: "도타 2",
            gameCount: 0,
            imgPath: "../images/swip/icon_dota_2.svg",
            id: "dota2",
        },
        {
            kind: "리그 오브 레전드",
            gameCount: 0,
            imgPath: "../images/swip/icon_league_of_legends.svg",
            id: "leagueoflegends",
        },
        {
            kind: "오버워치",
            gameCount: 0,
            imgPath: "../images/swip/icon_overwatch_2.svg",
            id: "overwatch",
        },
        {
            kind: "스타크래프트 2",
            gameCount: 0,
            imgPath: "../images/swip/icon_starcraft_2.png",
            id: "starcraft2",
        },
        {
            kind: "워크래프트",
            gameCount: 0,
            imgPath: "../images/swip/icon_warcraft_iii.png",
            id: "warcraft",
        },
        {
            id: 'ageofempire',
            kind: '에이지 오브 엠파이어',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_ageofempire.png",

        },
        {
            id: 'counterstrike',
            kind: '카운터 스트라이크',
            imgPath: "../images/swip/game_ico_counterstrike.svg",
        },
        {
            id: 'leagueoflegends_wildlift',
            kind: '리그오브레전드 와일드리프트',
            gameCount: 0,
            //   label1: '와일드리프트',
            imgPath: "../images/swip/game_ico_leagueoflegends_wildlift.png",
        },
        {
            id: 'pentastorm',
            kind: '펜타스톰',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_pentastorm.png",
        },
        {
            id: 'rainbowsix',
            kind: '레인보우6',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_rainbowsix.png",
        },
        {
            id: 'soccerbattle',
            kind: '축구배틀',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_soccerbattle.png",
        },
        {
            id: 'valorant',
            kind: '발로란트',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_valorant.png",
        },
        {
            id: 'nbabattle',
            kind: 'NBA배틀',
            gameCount: 0,
            imgPath: "../images/swip/game_ico_nbabattle.png",
        },
    ]

    const [selected, setSelected] = useState("all");
    const [sportsCnt, setSportsCnt] = useState([]);
    const { type, sportId, baselineSetting } = props;
    const allCount = getAllCount(type);

    const onSelect = (id) => {
        setSelected(id);
        props.SetSportId(id);
        props.SetLocation("all");
        props.SetLeague("all");
        props.SetCurrentPage();
        if (sportId !== id) {
            props.ClearSportsList();
        }
    }

    useEffect(() => {
        setSelected(sportId)
    }, [sportId])

    useEffect(() => {
        setSelected("all");
        props.SetSportId("all");
        props.SetLocation("all");
        props.SetLeague("all");
        props.SetCurrentPage();
    }, [type])

    let swip = [];
    let extraArray = sports.slice(1, sports.length)
    switch (type) {
        case "esports":
            swip = esports;
            break;

        case "live":
            if (!isEmpty(baselineSetting) && !isEmpty(baselineSetting.sportLive)) {
                for (let i = 0; i < extraArray.length; i++) {
                    if (baselineSetting.sportLive.indexOf(extraArray[i].id.toString()) < 0) {
                        swip.push(extraArray[i])
                    }
                }
                swip.splice(0, 0, sports[0])
            } else {
                swip = sports;
            }
            break;
        default:
            if (!isEmpty(baselineSetting) && !isEmpty(baselineSetting.sportPrematch)) {
                for (let i = 0; i < extraArray.length; i++) {
                    if (baselineSetting.sportPrematch.indexOf(extraArray[i].id.toString()) < 0) {
                        swip.push(extraArray[i])
                    }
                }
                swip.splice(0, 0, sports[0])
            } else {
                swip = sports;
            }
            break;
    }
    if (!isEmpty(allCount)) {
        for (let i = 0; i < swip.length; i++) {
            if (swip[i].id === "all") {
                swip[i].gameCount = allCount.count;
            }
            allCount.data.forEach(element => {
                if (element.id == swip[i].id) {
                    swip[i].gameCount = element.count;
                }
            })
        }
    }
    // console.log(swip,eventCount);
    // console.log(allCount)
    // useEffect(() => {
    //     const allCount = getAllCount(type);
    //     if (!isEmpty(allCount)) {
    //         // console.log(allCount)
    //         for (let i = 0; i < swip.length; i++) {
    //             if (swip[i].id === "all") {
    //                 swip[i].gameCount = allCount.count;
    //             }
    //             allCount.data.forEach(element => {
    //                 // console.log(allCount[key], key)
    //                 if (element.id == swip[i].id) {
    //                     swip[i].gameCount = element.count;
    //                 }
    //             })
    //         }
    //         setSportsCnt(swip)
    //         // console.log(swip);
    //     }
    // }, [allCount])


    return (
        <div className="con_box00">
            <div className="s_tab_wrap" style={{ width: "100%", overflow: "auto" }}>
                <ul style={{ display: "flex", height: "50px" }}>
                    {
                        swip.map((item, index) => {
                            if (!isEmpty(item.status)) {
                                if (item.status == false) return (<div key={index}></div>)
                            }
                            // console.log(item);
                            return (
                                <li className={`event column ${selected === item.id && "active"}`} key={index} onClick={() => onSelect(item.id)}>
                                    <a className="button">
                                        <span className={` ${selected === item.id ? "s_tabon" : "s_tab"}`}>
                                            <img src={item.imgPath} className="sports-icon" width="20px" alt="" />
                                            <span className="s_tab_ab">
                                                {Number(item.gameCount).toLocaleString()}
                                            </span>
                                            {item.kind}
                                        </span>
                                    </a>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    );
};
const mapStateToProps = state => ({
    sportId: state.sports.sportId,
    allCount: state.sports.allCount,
    baselineSetting: state.sports.baselineSetting
})

export default connect(mapStateToProps, {
    SetLocation,
    SetLeague,
    SetSportId,
    SetCurrentPage,
    ClearSportsList
})(Swipbox);


// WEBPACK FOOTER //
// ./src/components/sports/Swipbox.js